// extracted by mini-css-extract-plugin
module.exports = {"reportCardStatsPreview":"report-card-stats-preview_reportCardStatsPreview__3PYPx"};